import { openBlock as t, createElementBlock as a, createElementVNode as l } from "vue";
const m = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(o, e) {
  return t(), a("svg", m, [...e[0] || (e[0] = [
    l("mask", {
      id: "a",
      fill: "#fff"
    }, [
      l("path", { d: "M12 4.69c2.288-2.253 5.997-2.253 8.284 0a5.703 5.703 0 0 1 0 8.155L12 21l-8.284-8.155a5.704 5.704 0 0 1 0-8.156c2.216-2.181 5.766-2.25 8.065-.205z" })
    ], -1),
    l("path", {
      fill: "currentColor",
      d: "m12 4.69-1.368 1.459 1.402 1.314 1.37-1.348zm8.284 0 1.403-1.426zm0 8.155 1.403 1.425zM12 21l-1.403 1.425L12 23.806l1.403-1.38zm-8.284-8.155L2.313 14.27zm0-8.156L2.313 3.264zm8.065-.205 1.368-1.459-.019-.018-.02-.017zM12 4.69l1.403 1.426a3.923 3.923 0 0 1 5.478 0l1.403-1.426 1.403-1.425c-3.066-3.018-8.024-3.018-11.09 0zm8.284 0-1.403 1.426a3.704 3.704 0 0 1 0 5.304l1.403 1.426 1.403 1.425a7.704 7.704 0 0 0 0-11.006zm0 8.156-1.403-1.426-8.284 8.156L12 21l1.403 1.425 8.284-8.155zM12 21l1.403-1.425L5.12 11.42l-1.403 1.425-1.403 1.425 8.284 8.155zm-8.284-8.155 1.403-1.426a3.704 3.704 0 0 1 0-5.304L3.716 4.689 2.313 3.264a7.704 7.704 0 0 0 0 11.006zm0-8.156 1.403 1.426a3.925 3.925 0 0 1 5.333-.136l1.33-1.495L13.11 2.99C10.03.25 5.284.34 2.313 3.264zm8.065-.205-1.368 1.46.22.205L12 4.689l1.368-1.459-.219-.205z",
      mask: "url(#a)"
    }, null, -1)
  ])]);
}
const z = { render: r };
export {
  z as default,
  r as render
};
